import type { RouteRecordRaw } from 'vue-router';

import { defaultLayoutComponents, defaultLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const ImpersonationRoute: RouteRecordRaw = {
	path: '/impersonation',
	name: ROUTE_KEYS.IMPERSONATION,
	meta: {
		label: 'impersonation.page-title'
	},
	props: {
		...defaultLayoutProps
	},
	components: {
		default: () => import('./impersonation.page.vue'),
		...defaultLayoutComponents
	}
};

export default ImpersonationRoute;
